import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import _ from 'lodash';
import PublicHeader from '../../components/public-header';
import InfluencerAuthorisationCard from '../../components/influencer-authorisation-card';
import hasRESTClient from '../../hocs/has-rest-client';

class Creator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isError: false,
      influencer: null,
    };
  }

  async componentDidMount() {
    const { buildRESTClient, params: { id } } = this.props;
    const client = buildRESTClient({
      baseURL: process.env.REACT_APP_PUBLIC_ACCESS_API,
      hasToken: false,
    });
    const response = await client.get(`influencers/${id}`).catch(() => {
      this.setState({
        isLoading: false,
        isError: true,
      });
    });
    if (!response) {
      return;
    }
    const influencer = _.get(response, 'data.data.influencer', {});
    this.setState({
      influencer,
      isLoading: false,
      isError: false,
    });
  }

  render() {
    const { influencer, isLoading, isError } = this.state;
    return (
      <div>
        <PublicHeader />
        <InfluencerAuthorisationCard
          isLoading={isLoading}
          isError={isError}
          {...influencer}
        />
      </div>
    );
  }
}

export default compose(
  withRouter,
  hasRESTClient,
)(Creator);



/** WEBPACK FOOTER **
 ** ./src/containers/creator/index.js
 **/